import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DependenteComponent } from './components/dependente/dependente.component';
import { EnderecoEntregaComponent } from './components/endereco-entrega/endereco-entrega.component';
import { FinalizacaoComponent } from './components/finalizacao/finalizacao.component';
import { FormaEntregaComponent } from './components/forma-entrega/forma-entrega.component';
import { FormaPagamentoComponent } from './components/forma-pagamento/forma-pagamento.component';
import { HomeComponent } from './components/home/home.component';
import { InfoErroComponent } from './components/info-erro/info-erro.component';
import { ListaMaterialComponent } from './components/lista-material/lista-material.component';
import { MinhasComprasComponent } from './components/minhas-compras/minhas-compras.component';
import { PoliticaPrivacidadeComponent } from './components/politica-privacidade/politica-privacidade.component';
import { PoliticaVendasComponent } from './components/politica-vendas/politica-vendas.component';
import { minhasComprasGuard } from './shared/guards/minhas-compras.guard';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'politica-vendas', component: PoliticaVendasComponent },
  { path: 'politica-privacidade', component: PoliticaPrivacidadeComponent },
  { path: 'dependente', component: DependenteComponent },
  { path: 'lista-material', component: ListaMaterialComponent },
  { path: 'forma-entrega', component: FormaEntregaComponent },
  { path: 'endereco-entrega', component: EnderecoEntregaComponent },
  { path: 'forma-pagamento', component: FormaPagamentoComponent },
  { path: 'finalizacao', component: FinalizacaoComponent },

  { path: 'info-erro', component: InfoErroComponent },
  
  { path: 'minhas-compras', canActivate: [minhasComprasGuard], component: MinhasComprasComponent },

  { path: '**', redirectTo: '', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
